import React, { useState, useEffect } from 'react'
import { Panel, Form, Button, Radio, RadioGroup, Row, Col, Message, ControlLabel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getRequiredData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../../src/components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { isEmpty } from 'lodash-es'
import {
  getCloseOfProjectFileCoworker,
  saveCloseOfProjectFileCoworker,
  updateCloseOfProjectFileNameCoworker,
  downloadCloseOfProjectFileCoworker,
  deleteCloseOfProjectFileNameCoworker,
  updateCloseOfProjectCoworkerForm,
  getCloseOfProjectPaymentQr,
  getCalculateTellerPayment,
} from '../../redux/actions/closeOfProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import KycMessage from '../../components/message/kycMessage/KycMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import refundPaymentQr from '../../resources/images/qrMock.png'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import ClosureAttachmentWidget from '../closureAttachmentWidget/ClosureAttachmentWidget'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { getValueFromOptions } from '../../utils/dataUtil'
import CountDown from '../../components/utils/CountDown'

export default function CloseProjectWidget({
  schema: _schema,
  evaluationId,
  notConfirmIP,
  isDraftAssessment,
  statusConfirmActualResult,
  ...props
}) {
  const { showCommandButton, isEditAll, isApprove } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues, watch } =
    useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [closeTypeSelected, setCloseTypeSelected] = useState(_schema?.closeType?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [uploadError, setUploadError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()
  const [isErrorFileList, setIsErrorFileList] = useState(false)
  const [isShowRefundQr, setIsShowRefundQr] = useState(false)
  const [refundAmountValue, setRefundAmountValue] = useState(false)
  const [qrcodePayment, setQrCodePayment] = useState()
  const [qrcodeExpire, setQrcodeExpire] = useState()
  const [calculateProject, setCalculateProject] = useState()

  const [closureAttachmentNew, setClosureAttachmentNew] = useState()
  // console.log('evaluationId+++', evaluationId)

  // console.log('gggooo => ', isConfirmIP)

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(() => {
    if (!showCommandButton) {
      return
    }
    setIsShowRefundQr(false)
  }, [closeTypeSelected, showCommandButton])

  useEffect(() => {
    if (_schema) {
      register(_schema?.closeType?.name, _schema?.closeType?.value)
      setValue(_schema?.closeType?.name, _schema?.closeType?.value)
      setCloseTypeSelected(_schema?.closeType?.value)

      register(_schema?.refundAmount?.name, _schema?.refundAmount?.value)
      setValue(_schema?.refundAmount?.name, _schema?.refundAmount?.value)
      setRefundAmountValue(_schema?.refundAmount?.value)

      setClosureAttachmentNew(_schema?.closureAttachment?.fileList?.value)
    }
  }, [_schema])

  const handleShowRefundQr = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getCloseOfProjectPaymentQr(projectId, refundAmountValue, false)
      if (response.success) {
        if (response.model.expire) {
          const target = new Date(response.model.expire)
          const diffSeconds = Math.floor((target.getTime() - Date.now()) / 1000)

          setQrcodeExpire(diffSeconds)
        }

        setQrCodePayment('data:image/png;base64,' + response.model.qrCodePaymentImage)
      }
    } catch (e) {
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleCallCloseProjectCalculate = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getCalculateTellerPayment(projectId)
      if (response.success) {
        console.log('response', response)
        console.log('formSchema.closeType.name', formSchema.closeType.name)
        console.log('response.model.closeType', response.model.closeType)
        console.log('formSchema.refundAmount.name', formSchema.refundAmount.name)
        console.log('response.model.tellerPaymentAmount', response.model.tellerPaymentAmount)

        setCalculateProject(response.model)

        setCloseTypeSelected(response.model.closeType)
        setValue(formSchema.closeType.name, response.model.closeType)

        setRefundAmountValue(response.model.tellerPaymentAmount)
        setValue(formSchema.refundAmount.name, response.model.tellerPaymentAmount)
      }
    } catch (e) {
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errorMessage || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    // ย้ายไปใช้ แนบไฟล์ตาม type
    // if (
    //   isRequired(formSchema.uploadDocuments?.fileList.validators) &&
    //   formSchema.uploadDocuments?.fileList.value.length === 0 &&
    //   closeTypeSelected == 2
    // ) {
    //   let reqData = getRequiredData(formSchema.uploadDocuments?.fileList.validators)
    //   setIsErrorFileList(reqData.errorMessage)
    //   return
    // }

    const requiredFile =
      closureAttachmentNew?.filter((item) => {
        if (item.type == '1' && closeTypeSelected == '1') {
          //แจ้งขอเบิกเงิน = ไม่บังคับแนบ หลักฐานการโอนเงินคืน สสส.
          return false
        }
        return item.isRequired && item.path == null
      }) || []

    if (requiredFile.length > 0) {
      notification.open('error', {
        title: 'กรุณาแนบไฟล์เอกสารประกอบการปิดโครงการให้ครบถ้วน',
        duration: 5000,
      })
      return
    }

    let request = {
      projectVersionId: projectId,
      value: data[formSchema.note.name],
      approveType: isApprove ? data[formSchema.approveType.name] : 0,

      note: data[formSchema.note.name],
      closeType: data[formSchema.closeType.name] || 0,
      refundAmount: data[formSchema.refundAmount.name] || 0,
    }
    setRequest(request)
    console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateCloseOfProjectCoworkerForm(projectId, request)
      console.log('response', response)
      if (response.success || response.forms.requestNote) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message)
      }
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setIsError(e?.response?.data?.errors?.message)
      } else {
        setIsError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const handleCallUploadFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setUploadError()
    try {
      const response = await saveCloseOfProjectFileCoworker(projectId, request)
      setFormSchema((state) => {
        return {
          ...state,
          uploadDocuments: response,
        }
      })
      setUploadError(false)
      setIsErrorFileList(false)
    } catch (e) {
      setUploadError('อัปโหลดไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallDeleteFiles = async (request) => {
    startLoading()
    setIsLoading(true)
    setDeleteError(false)
    try {
      const response = await deleteCloseOfProjectFileNameCoworker(projectId, request.id)
      if (response == 200) {
        const res = await getCloseOfProjectFileCoworker(projectId)
        setFormSchema((state) => {
          return {
            ...state,
            uploadDocuments: res,
          }
        })
      }
    } catch (e) {
      setDeleteError('ลบไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallRenameFile = async (request) => {
    startLoading()
    setIsLoading(true)
    setRenameError()
    try {
      const response = await updateCloseOfProjectFileNameCoworker(projectId, request.id, request)
      setFormSchema((state) => {
        return {
          ...state,
          uploadDocuments: response,
        }
      })
      setRenameError(false)
    } catch (e) {
      setRenameError('แก้ไขชื่อไฟล์ไม่สำเร็จ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    console.log('fileObj ', fileObj)
    try {
      const file = await downloadCloseOfProjectFileCoworker(projectId, fileObj.path)
      console.log('file ', file)
      previewFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await downloadCloseOfProjectFileCoworker(projectId, fileObj.path)
      downloadFile(file, fileObj.name)
    } catch (err) {
      notification.open('error', {
        title: 'ดาวน์โหลดเอกสารไม่สำเร็จ',
      })
    }
    doneLoading()
  }

  const handleOnClickUpload = (filesData) => {
    if (isEmpty(filesData?.attachFiles)) {
      return
    }
    const formData = new FormData()
    filesData?.attachFiles.forEach((element) => {
      formData.append('files', element.blobFile)
    })
    handleCallUploadFiles(formData)
  }

  const handleOnClickDelete = (fileIndex) => {
    if (!formSchema?.uploadDocuments.fileList?.value?.[fileIndex]?.id) {
      return
    }
    const request = {
      id: formSchema.uploadDocuments.fileList.value[fileIndex].id,
      fileName: formSchema.uploadDocuments.fileList.value[fileIndex].name,
    }
    handleCallDeleteFiles(request)
  }

  const handleOnClickRenameFile = (file, newName) => {
    if (!newName) {
      return
    }
    console.log('file', file)
    const request = {
      id: file.id,
      //name: newName,
      label: newName,
    }

    handleCallRenameFile(request)
  }

  const msgConfirmActualResult = () => {
    if (statusConfirmActualResult?.confMessage?.length <= 0) {
      return ''
    }

    let itemStr = 'กรุณายืนยันผลการดำเนินการจริง <br /> <br />'

    statusConfirmActualResult?.confMessage?.map((item, index) => {
      itemStr += `${index + 1})  ${item} <br />`
    })

    return (
      <Row style={{ marginBottom: 20, marginLeft: 10, marginTop: 20 }}>
        <Message
          // key={index}
          showIcon
          type="error"
          description={<div dangerouslySetInnerHTML={{ __html: itemStr || '' }} />}
          style={{ marginBottom: 10 }}
        />
      </Row>
    )
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <Panel
        shaded
        header={formSchema.header}
        eventKey={2}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {showCommandButton && (
          <>
            <Button appearance="primary" onClick={handleCallCloseProjectCalculate}>
              ประมวลผลเพื่อขอปิดโครงการ
            </Button>
            <br />
            <br />
          </>
        )}

        {!isEmpty(calculateProject?.message) && (
          <>
            <Message description={<p>{calculateProject?.message}</p>} type="warning" icon />
          </>
        )}

        {showCommandButton ? (
          <>
            {formSchema?.closeType && (closeTypeSelected || calculateProject) && (
              <>
                <ErrorMessage error={errors[formSchema.closeType.name]} />
                <Controller
                  key={formSchema.closeType.name}
                  name={formSchema.closeType.name}
                  control={control}
                  rules={isValidators(formSchema.closeType.validators)}
                  defaultValue={closeTypeSelected}
                  value={closeTypeSelected}
                  render={(props) => {
                    return (
                      <RadioGroup
                        value={closeTypeSelected}
                        onChange={(value) => {
                          props.onChange(value)
                          setCloseTypeSelected(value)
                        }}
                      >
                        {formSchema.closeType?.options?.map((item) => {
                          return (
                            <Radio value={item.value} disabled={!showCommandButton}>
                              {item.label}{' '}
                            </Radio>
                          )
                        })}
                      </RadioGroup>
                    )
                  }}
                />
              </>
            )}
          </>
        ) : (
          <>
            <b>{getValueFromOptions(formSchema.closeType.options, formSchema.closeType.value)}</b>
          </>
        )}

        {closeTypeSelected == 2 && (
          <>
            <ErrorMessage error={errors[formSchema.refundAmount.name]} />
            <Row style={{ marginLeft: '1px' }}>
              {formSchema.refundAmount.label}
              <span>
                {' '}
                {formSchema.refundAmount.preLabel}
                {showCommandButton ? (
                  <>
                    <Controller
                      name={formSchema.refundAmount.name}
                      control={control}
                      defaultValue={refundAmountValue || 0}
                      rules={isRequired ? { required: 'กรุณากรอกจำนวนเงิน' } : {}}
                      value={refundAmountValue}
                      render={(props) => {
                        return (
                          <NumberFormat
                            className={classNames(
                              'rs-input',
                              errors[formSchema.refundAmount.name] && 'is-error'
                            )}
                            thousandSeparator={true}
                            value={refundAmountValue}
                            onValueChange={(value) => {
                              props.onChange(value.floatValue)
                              setIsShowRefundQr(false)
                              setRefundAmountValue(value.floatValue)
                            }}
                            style={{ display: 'unset', width: 120, margin: '0px 15px' }}
                          />
                        )
                      }}
                    />
                    {formSchema.refundAmount.postLabel}
                    {formSchema.enableQrPayment && (
                      <SaveButton
                        icon="qrcode"
                        style={{ marginLeft: 10 }}
                        disabled={!(Number(refundAmountValue) > 0)}
                        onClick={handleShowRefundQr}
                      >
                        สร้าง QR สำหรับโอนเงิน
                      </SaveButton>
                    )}
                  </>
                ) : (
                  <b> {budgetFormat(formSchema.refundAmount.value)} </b>
                )}
                {!showCommandButton && formSchema.refundAmount.postLabel}
              </span>
            </Row>
            {qrcodePayment && (
              <Row style={{ marginTop: 10, marginLeft: '1px', textAlign: 'center' }}>
                <img
                  src={qrcodePayment}
                  alt="QR code for teller payment"
                  style={{
                    width: 300,
                    maxWidth: '100%',
                    height: 'auto',
                    //display: 'block',
                  }}
                />
                <CountDown
                  second={qrcodeExpire}
                  preTxt={'หมดเวลาในอีก'}
                  onDone={(result) => {
                    setQrCodePayment('')
                    setQrcodeExpire(0)
                  }}
                />
              </Row>
            )}

            {/* {formSchema?.uploadDocuments &&
            (showCommandButton ? (
              <>
                <br />
                <ControlLabel
                  className={classNames(
                    isRequired(formSchema.uploadDocuments.fileList.validators) && 'required'
                  )}
                >
                  {formSchema.uploadDocuments.header}
                </ControlLabel>

                {isErrorFileList && <Message showIcon type="error" description={isErrorFileList} />}
                <AttachFilesForm
                  schema={formSchema.uploadDocuments?.fileList}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  onSubmit={handleSubmit(handleOnClickUpload)}
                  onDelete={handleOnClickDelete}
                  onUpdate={handleOnClickRenameFile}
                  onDownload={onDownload}
                  onPreview={onPreview}
                  isChangSeqNo={false}
                  isEditErr={renameError}
                  isUploadErr={uploadError}
                  isDeleteError={deleteError}
                  loading={isLoading}
                />
              </>
            ) : (
              <>
                <br />
                <p>{formSchema.uploadDocuments.header}</p>
                <AttachFilesView
                  schema={formSchema.uploadDocuments?.fileList}
                  onDownload={onDownload}
                  onPreview={onPreview}
                />
              </>
            ))} */}
          </>
        )}

        {/* แนบไฟล์ ปิดโครงการ ตามประเภท (ใหม่) */}
        {formSchema?.closureAttachment && (
          <>
            <br />
            <ClosureAttachmentWidget
              disabledForm={!showCommandButton || formSchema?.closureAttachment.disabled}
              schema={formSchema?.closureAttachment}
              onUploadSuccess={(e) => setClosureAttachmentNew(e)}
              closeTypeSelected={closeTypeSelected}
            />
            <br />
          </>
        )}

      {formSchema.approveType && isApprove && (
        <>
          <br />
          <ErrorMessage error={errors[formSchema.approveType.name]} />
          <Controller
            key={formSchema.approveType.name}
            name={formSchema.approveType.name}
            control={control}
            rules={isValidators(formSchema.approveType.validators)}
            defaultValue={formSchema.approveType.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                  }}
                >
                  {formSchema.approveType?.options?.map((item) => {
                    return <Radio value={item.value}>{item.label} </Radio>
                  })}
                </RadioGroup>
              )
            }}
          />
        </>
      )}

      {showCommandButton && (
        <>
          {formSchema.alertMessages?.map((item) => {
            return <Message showIcon type="warning" description={item.message} />
          })}
          {formSchema.verifyKyc && <KycMessage schema={formSchema.verifyKyc} />}
          <hr />

          {isError && <Message showIcon type="error" description={isError} />}

          {isDraftAssessment && (
            <Message
              showIcon
              type="error"
              description={'กรุณาบันทึกแบบประเมินปิดโครงการ'}
              style={{ marginBottom: 10 }}
            />
          )}
            <br />
          </>
        )}

        {formSchema?.note &&
          (showCommandButton ? (
            <InputForm
              schema={formSchema.note}
              rows={3}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          ) : (
            <>
              <p>{formSchema.note.label}</p>
              <p style={{ textIndent: '2.5em' }}>{formSchema.note.value}</p>
            </>
          ))}

        {formSchema.approveType && isApprove && (
          <>
            <br />
            <ErrorMessage error={errors[formSchema.approveType.name]} />
            <Controller
              key={formSchema.approveType.name}
              name={formSchema.approveType.name}
              control={control}
              rules={isValidators(formSchema.approveType.validators)}
              defaultValue={formSchema.approveType.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchema.approveType?.options?.map((item) => {
                      return <Radio value={item.value}>{item.label} </Radio>
                    })}
                  </RadioGroup>
                )
              }}
            />
          </>
        )}

        {showCommandButton && (
          <>
            {formSchema.alertMessages?.map((item) => {
              return <Message showIcon type="warning" description={item.message} />
            })}
            {formSchema.verifyKyc && <KycMessage schema={formSchema.verifyKyc} />}
            <hr />

            {isError && <Message showIcon type="error" description={isError} />}

            {isDraftAssessment && (
              <Message
                showIcon
                type="error"
                description={'กรุณาทำการประเมินปิดโครงการ'}
                style={{ marginBottom: 10 }}
              />
            )}

            {notConfirmIP && (
              <Message
                showIcon
                type="error"
                description={'กรุณายืนยันสรุปจำนวนงานวิจัย และ นวัตกรรม ก่อน'}
                style={{ marginBottom: 10 }}
              />
            )}

            {!statusConfirmActualResult?.confStatus && msgConfirmActualResult()}

            <SaveButton
              icon="send"
              onClick={handleSubmit(onSubmit)}
              disabled={
                !!formSchema.verifyKyc ||
                isDraftAssessment ||
                notConfirmIP ||
                !statusConfirmActualResult?.confStatus ||
                formSchema.alertMessages.length > 0 ||
                closeTypeSelected == null
                //closureAttachmentNew?.filter(item => item.isRequired && item.path == null).length > 0
              }
              children={formSchema.buttonText}
            />

            {/* <Button
            ripple
            // appearance="ghost"
            color="rgb(45, 168, 136)"
            appearance="primary"
            onClick={handleSubmit(onSubmit)}
            // || isConfirmIP
            disabled={!!formSchema.verifyKyc || evaluationId || formSchema.alertMessages.length > 0}
          >
            {formSchema.buttonText}
          </Button> */}
          </>
        )}

        <ConfirmWidget
          title={`ยืนยันการ${formSchema.buttonText}`}
          // confirmBtn={`ยืนยัน${formSchema.buttonText}`}
          // cancleBtn={`ยกเลิก${formSchema.buttonText}`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการ${formSchema.buttonText}`}
          onCancle={onCancle}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}

const newSchema = {
  closeType: {
    name: 'closeType',
    value: null,
    options: [
      { value: 1, label: 'แจ้งโอนเงินคืน' },
      { value: 2, label: 'แจ้งขอเบิกเงิน' },
    ],
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาเลือก การแจ้งขอปิดโครงการ',
      },
    ],
  },
  refundAmount: {
    name: 'refundAmount',
    value: 0,
    label: 'เงินคืนตามใบแจ้งการฝากเงินเข้าธนาคาร (Teller Payment)',
    preLabel: 'จำนวน',
    postLabel: 'บาท',
    validators: [
      {
        type: 'REQUIRED',
        value: null,
        errorMessage: 'กรุณาเลือก การแจ้งขอปิดโครงการ',
      },
    ],
  },
  uploadDocuments: {
    disabled: false,
    header: 'ไฟล์แนบหลักฐานการโอนเงิน',
    fileList: {
      name: 'attachFiles',
      value: [],
    },
  },
}
